import { STORAGE_PREFIX } from '../config'

const localStorage = window.localStorage

export default {
  getItem (name, defaultValue = null) {
    let item = localStorage.getItem(STORAGE_PREFIX + name)
    item = item !== undefined ? item : defaultValue
    return item
  },

  setItem (name, value) {
    localStorage.setItem(STORAGE_PREFIX + name, value)
  },

  removeItem (name) {
    localStorage.removeItem(STORAGE_PREFIX + name)
  }
}
